<template>
  <span :class="{ redLabel: redLabel === true}" >{{ divisionRenderTextComputed }}</span>
</template>

<script>

import { DivisionType } from '../../constants'
import { mapState } from 'vuex'

export default {
  name: 'DivisionTypeText',
  props: {
    division_type: {
      type: String,
      default: null
    },
    labelDefault: {
      type: String,
      default: null
    },
    red: {
      type: Boolean,
      default: false
    },
    displayRemark: {
      type: Boolean,
      default: false
    },
    remark: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      redLabel: this.red && this.division_type === DivisionType[2].value
    }
  },
  created () {
    if (this._props.red === true && this._props.division_type === DivisionType[2].value) {
      this.redLabel = true
    } else {
      this.redLabel = false
    }
  },
  computed: {
    ...mapState(['currentLanguage']),
    divisionRenderTextComputed () {
      return this.divisionRenderText(this.division_type)
    }
  },
  methods: {
    translations (key) {
      const language = require(`@/locales/${this.currentLanguage}.json`)
      const keys = key.split('.')
      let value = language

      for (const k of keys) {
        value = value[k]
        if (!value) break
      }

      return value || key
    },
    divisionRenderText (divisonType) {
      if (this._props.displayRemark === true && divisonType === DivisionType[0].value) {
        return this._props.remark
      }
      for (let index = 0; index < DivisionType.length; index++) {
        const element = DivisionType[index]
        if (element.value === divisonType) {
          return this.translations(`order_status.${element.label}`)
        }
      }
      return this._props.labelDefault !== 'null' ? this._props.labelDefault : '-----------'
    }
  }
}
</script>

<style>
.redLabel {
  color: red
}
</style>
